import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import { apiInstance } from '../../axiosApi';

export const brandingDetailsGet = createAsyncThunk(
  'company-branding/company-personalization',
  async (params) => {
    return await apiInstance.get('/company-branding/company-personalization', { params });
  }
);

const initialState = {
  brandingDetails: null
};

const brandingDetailSlice = createSlice({
  name: 'brandingDetail',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(brandingDetailsGet.fulfilled, (state, action) => {
      state.brandingDetails = action?.payload?.data;
    });
  }
});

export default brandingDetailSlice.reducer;

export const selectBrandingDetails = (state) => state.brandingDetail.brandingDetails;
export const useBrandingDetails = () => {
  const brandingDetails = useSelector(selectBrandingDetails);
  return useMemo(() => brandingDetails, [brandingDetails]);
};
